import NewReferralWizardContainer from './NewReferralWizardContainer';

export default NewReferralWizardContainer;
